import { createContext } from "react";

export type UserAuthenticationActionsContextValue = {
  canWrite: boolean;
  isNavigationInProgress: boolean;
  isOrganizationOwner: boolean;
  isValidating: boolean;
  refresh: () => Promise<void>;
  setIsNavigationInProgress: (isNavigationInProgress: boolean) => void;
};

export default createContext<UserAuthenticationActionsContextValue>({
  canWrite: false,
  isNavigationInProgress: false,
  isOrganizationOwner: false,
  isValidating: false,
  refresh: () => Promise.resolve(undefined),
  setIsNavigationInProgress: () => {},
});
